import { themeBackgrounds, themeColors } from "@dana/MobiusOverrides/styles/colors";
import { fontSizes, fontWeights, lineHeights } from "@dana/MobiusOverrides/styles/typography";
import { headerShipToAddressStyles } from "@dana/Overrides/Widgets/Common/HeaderShipToAddress";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";

import { css } from "styled-components";

headerShipToAddressStyles.titleTypographyCustomer = mergeToNew(headerShipToAddressStyles.titleTypographyCustomer, {
    color: themeColors.primary.white,
    ellipsis: false,
    transform: "capitalize",

    css: css`
        margin-left: 0px;
    `
});

headerShipToAddressStyles.titleClickableCustomer = mergeToNew(headerShipToAddressStyles.titleClickableCustomer, {
    css: css`
        margin-left: 0px;
        width: 100%;

        &.clicked {
            span {
                color: ${themeColors.secondary.danaBrightBlue};
            }
        }
    `,
});

headerShipToAddressStyles.drawer = mergeToNew(headerShipToAddressStyles.drawer, {
    css: css`
        width: 50%;
        margin: auto;
        position: absolute;
        top: 200px;
        transform: translate(50%);
    `,

    cssOverrides: {
        headlineTypography: {
            css: css`
                font-size: ${fontSizes.xxLarge};
                font-weight: ${fontWeights.semiBold};
                line-height: ${lineHeights.default};
                padding: 32px 0px 9px 30px;
                margin-bottom: 0px;
            `,
        },
        drawerBody: {
            css: css`
                padding: 40px;
            `,
        },

        drawerTitle: {
            css: css`
                padding: 40px 40px 40px 0px;
            `,
        },
    },

    closeButtonProps: {
        css: css`
            position: absolute;
            right: 8px;
            top: 8px;
            padding: 0px;
            border: none;
        `,
    },
});
